// extracted by mini-css-extract-plugin
export default {"contact":"PricingContactLine_contact__1k1vm"};